import React, { useState, useEffect } from "react";
import { Modal } from "react-responsive-modal";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import CustomInput from "components/CustomInput/CustomInput";
import email_image from "assets/img/email_code.png";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import CustomButton from "components/CustomButton";
import Loader from "components/Loader";
import * as Yup from "yup";
import "assets/scss/partials/authentication.scss";
import "assets/scss/base/custom.scss";
import { useFormik } from "formik";
import AuthService from "services/AuthService";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useCountDownTimer from "hooks/useCountDownTimer";
import { useToasts } from "react-toast-notifications";

var styles = {
  emailImage: {
    width: "45%",
    maxWidth: "15%",
  },
  codeInformation: {
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    gap: "5px",
  },
  mailText: {
    color: "#3f51b5",
    fontWeight: "400",
  },
  alertText: {
    color: "#f44336",
    fontWeight: "400",
  },
  time: {
    color: "#fea000",
    fontSize: "25px",
    fontWeight: "500",
    padding: "15px 0px",
  },
  disableResend: {
    pointerEvents: "none",
    cursor: "default",
    color: "gray",
    margin: "3px",
  },
  enableResend: {
    pointerEvents: "all",
    cursor: "pointer",
    color: "#bf780e",
    textDecoration: "underline",
    margin: "3px",
  },
  recieveCodeText: {
    display: "flex",
    justifyContent: "center",
    padding: "10px 0px",
  },
  inputField: {
    marginBottom: "20px",
  },
};

function UserVerifyEmail({
  openModal,
  email,
  closeModal,
  previousEmail,
  setNewEmail,
}) {
  const classes = styles;
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [disableResendCode, setDisableResendCode] = useState(true);
  const [start, setStart] = useState(false);
  const { date } = useCountDownTimer({
    start,
    setDisableResendCode,
    disableResendCode,
  });
  const { addToast } = useToasts();

  useEffect(() => {
    if (openModal) {
      return setStart(true);
    }
  }, [openModal]);

  const formik = useFormik({
    initialValues: {
      code: "",
    },
    validateOnBlur: false,
    validationSchema: verificationValidationSchema(),
    onSubmit: async (values) => {
      try {
        setLoading(true);

        await AuthService.verifyEmail({
          email: previousEmail,
          updated_email: email,
          verification_code: values.code,
        });

        setNewEmail({ email: email });

        addToast("User Email updated successfully. ", {
          appearance: "success",
        });
        closeModal();
      } catch (error) {
        if (error.response) {
          setErrorState(
            error.response?.data.errors?.verification_code[0] ??
              error.response.data.message
          );
        }
      }
      setLoading(false);
    },
  });

  const setErrorState = (message) => {
    setErrorMessage(message);
    setTimeout((_) => {
      setErrorMessage("");
    }, 4000);
  };

  const resendCode = async (event) => {
    event.preventDefault();
    try {
      AuthService.resendVerificationEmail({ email: email });
    } catch (e) {
      console.log(e.response.data.message);
      console.log(e);
    }
  };

  return (
    <Modal
      classNames={{
        modalContainer: "modalContainer",
        modal: "rootModalContainer",
      }}
      open={openModal}
      showCloseIcon={false}
      onClose={closeModal}
    >
      <div>
        <CloseIcon onClick={closeModal} className="verifyCloseIcon" />
      </div>
      <div className="content">
        <div className="textcenter heading">ReTeam Verify Account</div>
        <div style={classes.codeInformation}>
          <div>
            <img
              src={email_image}
              alt="email_image"
              style={classes.emailImage}
            />
          </div>
          <div>We have sent you a code on {email}</div>
          <div style={classes.mailText}>
          Please check your inbox and spam too for the mail
          </div>
          <div style={classes.alertText}>
            If you haven't received the email please wait for 20 minutes.
          </div>
          <div style={classes.time}>{date}</div>
        </div>
        <div className="formContent">
          <form noValidate onSubmit={formik.handleSubmit}>
            <div className="inputFields" style={classes.inputField}>
              <CustomInput
                id={"verification-code"}
                startIcon={
                  <FontAwesomeIcon icon={faEnvelope} className="formIcon" />
                }
                inputProps={{
                  type: "text",
                  placeholder: "Kindly write the verification code",
                  ...formik.getFieldProps("code"),
                  error: formik.errors.code || errorMessage,
                }}
              />
            </div>
            <CustomButton
              name={!loading ? "Verify" : <Loader width={40} height={40} />}
              disabled={loading && true}
            />
          </form>
        </div>
        <div className="textcenter">
          <Link to="/login">Back to login </Link>
        </div>
        <div style={classes.recieveCodeText}>
          <span>
            Didn't received code?{" "}
            <a
              href="/profile"
              style={
                disableResendCode ? classes.disableResend : classes.enableResend
              }
              onClick={(event) => resendCode(event)}
            >
              Resend Code
            </a>
          </span>
        </div>
      </div>
    </Modal>
  );
}

const verificationValidationSchema = () => {
  return Yup.object().shape({
    code: Yup.string().min(4).required(),
  });
};

export default UserVerifyEmail;
